import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Chip } from '@mui/material';
import { hasAuthourity } from '../../../../../lib/access.es6';
import { ClaimTypeEnum } from '../../../lib/enum';
import ViewDocument from '../../../../../shared-ui/ViewDocument/ViewDocument';
import { getPartnerGuid } from "../../../../../lib/access.es6";
import {
  omkLastExpenseDocuments,
  findUploadedDocument
} from "../../../../../lib/omkLastExpenseDocuments.es6";
import { payableForClaim } from "../../../../../lib/claimBenefitCaps.es6";

const ClaimDocuments = (props) => {
  const classes = useStyle();
  const [viewDocumentUrl, setViewDocumentUrl] = React.useState(null);
  const [numPages, setNumPages] = React.useState(null);
  const partnerGuid = getPartnerGuid();

  console.log("claim documents props", props)

  const claimDocs = props.claimDocuments || [];

  const staticHospitalDocs = [
    { description: " ID Front *" },
    { description: " ID Back *" },
    { description: "Hospital invoice/receipts *" },
    { description: "Discharge summary *" },
  ];

  const staticHospitalAccidentDocs = [
    { description: " ID Front *" },
    { description: " ID Back *" },
    { description: "Hospital invoice/receipts *" },
    { description: "Discharge summary *" },
    { description: "Police report *" },
  ];

  const staticDeathDocs = [
    { description: "ID document *" },
    { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const  accidentalDeath = [
  { description: "ID/Passport *" },
    { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const naturalDeath = [
   { description: "ID/Passport *" },
       { description: "Burial permit *" },
    { description: "Death Certificate *" },
  ];

  const totalPermanentDisability = [
    { description: "ID/Passport *" },
    { description: "Medical Report or Hospital Letter Indicating Permanent Disability *" },
 
  ];
  
  const partialPermanentDisability = [
     { description: "ID/Passport *" },
    { description: "Medical Report or Hospital Letter Indicating Partial Permanent Disability *" },
  ];

  const staticLastExpense = [
    { description: " ID Front *" },
    { description: " ID Back *" },
    { description: "Burial Permit *" },
    { description: "Birth certificate/Marriage certificate *" },
  ];

  const staticPermanentDisabilityDocs = [
    { description: "Claim form *" },
    { description: "Loan form *" },
    { description: "Loan statement *" },
    { description: "Loan repayment schedule *" },
    { description: "Borrower ID Front *" },
    { description: "Borrower ID Back *" },
    { description: "Police abstract *" },
    { description: "Doctors report *" },
  ];
  const staticPropertyDocs = [
    { description: "Claim form *" },
    { description: "Loan form *" },
    { description: "Loan statement *" },
    { description: "Loan repayment schedule *" },
    { description: "Borrower ID Front *" },
    { description: "Borrower ID Back *" },
    { description: "Police abstract *" },
    { description: "Photos of destroyed business *" },
  ];

  let staticDocs = [];
  // Optional docs appear in the checklist (uploadable) but are never required —
  // they don't show as "missing" and don't block finalisation.
  let optionalDocs = [];
  if (
    props.type === ClaimTypeEnum.FuneralAccidentalDeath ||
    props.type === ClaimTypeEnum.FuneralNaturalDeath
  ) {
    staticDocs = [...staticDeathDocs];
  }
  if (props.type === ClaimTypeEnum.HospiCashIllness) {
    staticDocs = [...staticHospitalDocs];
  }
  if (props.type === ClaimTypeEnum.HospiCashAccident) {
    staticDocs = [...staticHospitalAccidentDocs];
  }
  if (props.type === ClaimTypeEnum.LastExpense) {
    staticDocs = [...staticLastExpense];
  }
  if (props.type === ClaimTypeEnum.permanentDisability) {
    staticDocs = [...staticPermanentDisabilityDocs];
  }
  if (props.type === ClaimTypeEnum.Property) {
    staticDocs = [...staticPropertyDocs];
  }
  if (props.type === ClaimTypeEnum.AccidentalDeath) {
    staticDocs = [...accidentalDeath];
  }
  if (props.type === ClaimTypeEnum.NaturalDeath) {
    staticDocs = [...naturalDeath];
  }
  if (props.type === ClaimTypeEnum.TotalPermanentDisability) {
    staticDocs = [...totalPermanentDisability];
  }
  if (props.type === ClaimTypeEnum.PartialPermanentDisability) {
    staticDocs = [...partialPermanentDisability];
  }
  if (props.type === ClaimTypeEnum.OldMutualMalawiFuneral) {
    staticDocs = [...staticDeathDocs];
  }
  if(partnerGuid === "old_mutual_malawi" && props.claimDetails.claim_details.additional_details.age < 18){
    staticDocs = staticDocs.filter(doc => doc.description !== "ID document *");
    staticDocs.push({ description: "Burial Certificate  or School ID for Minors or Health Passport if deceased is below 5*" });
  
  }
   if(partnerGuid === "old_mutual_malawi" ){
    staticDocs = staticDocs.filter(doc => doc.description !== "Burial permit *" && doc.description !== "Death Certificate *" );
    staticDocs.push({ description: "Proof of death *" });
  
  }
  if(partnerGuid === "old_mutual_malawi" && props.claimDetails.claim_details.additional_details.cause_of_death === "Accidental death"){
    console.log("adding police report")
    staticDocs.push({ description: "Police Report *" });
  }
  if (partnerGuid === "omk") {
    const DEATH_CERT_THRESHOLD_IN_CENTS = 250000 * 100; // KES 250,000
    const claimBenefits =
      (props.claimDetails && props.claimDetails.benefits) || [];
    const claimBenefitAmountInCents = claimBenefits.reduce(function (max, benefit) {
      const amount =
        benefit && benefit.max_benefit_amount_in_cents
          ? benefit.max_benefit_amount_in_cents
          : 0;
      return amount > max ? amount : max;
    }, 0);

    // OMK "Last Expense" resolves to FuneralNaturalDeath. Use the SAME required-
    // document checklist as the client-facing app so the two stay in sync and
    // documents the client already uploaded match automatically (see the
    // alias-tolerant matching below) instead of showing as missing.
    if (props.type === ClaimTypeEnum.FuneralNaturalDeath) {
      const omkClaimDetails =
        (props.claimDetails && props.claimDetails.claim_details) || {};
      const omkClaimAdditional = omkClaimDetails.additional_details || {};
      const deceased =
        (props.claimDetails &&
          props.claimDetails.member &&
          props.claimDetails.member.dependant) ||
        {};

      // The checklist itself is derived in lib/ so the customer journey and the back
      // office cannot drift: a child's identity document is the birth certificate,
      // and an accidental death brings in the police / postmortem report.
      //
      // payableAmount has to be the CAPPED figure, which is what decides whether the
      // death certificate is mandatory. Passing the registered cover made the two
      // screens disagree on exactly the claims this exists for: a child of 8 on a
      // KES 500,000 tier is payable KES 100,000, so the expenses dialog raises one
      // invoice and needs no certificate to release a balance — while this checklist
      // demanded one and, because a missing row gates Finalise Documentation, blocked
      // the file over it. payableForClaim is the same derivation the dialog uses.
      const capped = payableForClaim(props.claimDetails, props.policy);
      const checklist = omkLastExpenseDocuments({
        dateOfBirth: omkClaimDetails.dependant_dob || deceased.date_of_birth,
        dateOfDeath:
          (props.claimDetails && props.claimDetails.event_date) ||
          omkClaimAdditional.date_of_death,
        ageAtDeath: omkClaimAdditional.age,
        relationship:
          omkClaimDetails.relationship_to_policyholder || deceased.relationship,
        causeOfDeath:
          omkClaimAdditional.cause_of_death || omkClaimDetails.cause_of_death,
        payableAmount: capped.payable
      });

      staticDocs = checklist.required;
      optionalDocs = checklist.optional;
    } else {
      // Other OMK claim types keep the existing back-office requirements.
      if (claimBenefitAmountInCents <= DEATH_CERT_THRESHOLD_IN_CENTS) {
        staticDocs = staticDocs.filter(function (doc) {
          return doc.description !== "Death Certificate *";
        });
      }
      staticDocs.push({ description: "Proof of Payment *" });
      staticDocs.push({ description: "AML Documents *" });
    }
  }

  // Match a checklist row against what is already on the claim, ignoring the
  // required-marker asterisk and case, and accepting any of the row's aliases — so a
  // document the client uploaded under an equivalent label (or under the label a
  // requirement used before it was reworded) shows as uploaded instead of missing.
  const missingStaticDocs = [];

  for (let doc of staticDocs) {
    if (!findUploadedDocument(claimDocs, doc)) {
      // Every outstanding row reads the same. A balance-gating row used to carry a
      // status of its own, which put it down the "uploaded" branch of the Actions
      // column — so the death certificate offered View and Delete for a file that
      // was never there, and read as though it had been uploaded automatically.
      // What the flag governs is finalisation, not presentation: it is still
      // excluded from the gate below.
      missingStaticDocs.push({ ...doc, status: "missing" });
    }
  }

  // Report the ACTUAL missing state up to the parent (which gates the
  // "Finalise Documentation" action). Done in an effect — not during render —
  // and reset to false once every required doc is present, so a stale "missing"
  // flag from an earlier render (before uploaded docs loaded) can't block
  // finalisation after the docs are in.
  //
  // Balance-gating rows are excluded from the gate on purpose. Counting them meant a
  // KES 500,000 claim with no death certificate could not be finalised, so the first
  // KES 250,000 — which is payable on the base documents alone — was unreachable.
  const hasMissingStaticDocs = missingStaticDocs.some(function (doc) {
    return !doc.gatesBalanceOnly;
  });
  React.useEffect(() => {
    if (props.toggleMissingDocs) {
      props.toggleMissingDocs(hasMissingStaticDocs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMissingStaticDocs]);

  // Optional docs that haven't been uploaded yet: shown so they can be
  // uploaded, but flagged "optional" (never "missing", never blocking).
  const optionalNotUploaded = optionalDocs
    .filter(function (doc) {
      return !findUploadedDocument(claimDocs, doc);
    })
    .map(function (doc) {
      return { ...doc, status: "optional" };
    });

  const result = [
    ...missingStaticDocs,
    ...optionalNotUploaded,
    ...claimDocs,
    { description: "", status: "any other doc" },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container spacing={2} className={classes.claimdocswrapper}>
          <Grid item xs={12} sm={12} md={12}>
            <TableInc
              columns={[
                {
                  title: "Document  Name",
                  field: "description",
                },
                {
                  title: "Status",
                  field: "created_At",
                  render: (rowData) =>
                    rowData.status === "missing" ? (
                      <Chip
                        size="small"
                        variant="outlined"
                        label={"missing"}
                        style={{
                          margin: "1px",
                          backgroundColor: "red",
                          color: "#fff",
                        }}
                      />
                    ) : rowData.status === "optional" ? (
                      <Chip
                        size="small"
                        variant="outlined"
                        label={"optional"}
                        style={{
                          margin: "1px",
                          backgroundColor: "#718096",
                          color: "#fff",
                        }}
                      />
                    ) : rowData.status === "any other doc" ? (
                      "upload any other doc"
                    ) : (
                      <Chip
                        size="small"
                        variant="outlined"
                        label={"uploaded"}
                        style={{
                          margin: "1px",
                          backgroundColor: "green",
                          color: "#fff",
                        }}
                      />
                    ),
                },

                {
                  title: "Actions",
                  field: "created_At",
                  render: (rowData) => {
                    return !(
                      rowData.status === "missing" ||
                      rowData.status === "optional" ||
                      rowData.status === "any other doc"
                    ) ? (
                      <div className={classes.actionbtn}>
                        <Tooltip title="View Document">
                          <span
                            onClick={() => setViewDocumentUrl(rowData.url)}
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                            }}
                          >
                            <VisibilityIcon sx={{ color: " #4B7E34" }} />
                          </span>
                        </Tooltip>

                        <Tooltip title="Download Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                            }}
                          >
                            <a
                              href={rowData.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FileDownloadIcon sx={{ color: " #000" }} />
                            </a>{" "}
                          </span>
                        </Tooltip>

                        <Tooltip title="Delete Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                              marginLeft: "5px",
                            }}
                            onClick={() =>
                              props.setClaimDocumentToDelete(rowData)
                            }
                          >
                            {" "}
                            <DeleteIcon sx={{ color: "#8F191C" }} />
                          </span>
                        </Tooltip>
                      </div>
                    ) : (
                      <div className={classes.actionbtn}>
                        <Tooltip title="Upload Document">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity("UPDATE_CLAIM")
                                ? "inline"
                                : "none",
                              marginLeft: "5px",
                            }}
                            onClick={() => {
                              props.setDescription(rowData.description);
                              props.openUploadDialog();
                            }}
                          >
                            {" "}
                            <FileUploadIcon sx={{ color: "#000" }} />
                          </span>
                        </Tooltip>
                      </div>
                    );
                  },
                },
              ]}
              data={result}
              options={{
                pageSize: 7,
                showTitle: false,
              }}
            />
          </Grid>

          <ViewDocument
            title="View Claim Documents"
            open={viewDocumentUrl}
            close={() => setViewDocumentUrl(null)}
            viewDocumentUrl={viewDocumentUrl}
            numPages={numPages}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClaimDocuments